// src/components/DownloadConsent.jsx
// CLAUDE.md "9. 보안 & 컴플라이언스" 5번 — 다운로드 전 법적 동의 필수.

import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { doc, updateDoc, serverTimestamp } from 'firebase/firestore';
import toast from 'react-hot-toast';

import { db } from '../firebase.js';

export default function DownloadConsent({ videoId, videoUrl }) {
  const { t } = useTranslation();
  const [agreed, setAgreed] = useState(false);
  const [downloading, setDownloading] = useState(false);

  async function handleDownload() {
    if (!agreed || !videoUrl) return;
    setDownloading(true);
    try {
      await updateDoc(doc(db, 'videos', videoId), {
        legalConsentAt: serverTimestamp(),
        downloadedAt: serverTimestamp(),
      });

      // <a download> 트릭으로 강제 다운로드
      const res = await fetch(videoUrl);
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `citizencast-${videoId}.mp4`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch (e) {
      toast.error(e.message || t('common.downloadFailed'));
    } finally {
      setDownloading(false);
    }
  }

  return (
    <div className="card space-y-3 border-2" style={{ borderColor: 'var(--color-primary)' }}>
      <label className="flex items-start gap-2 text-sm cursor-pointer">
        <input
          type="checkbox"
          className="mt-1"
          checked={agreed}
          onChange={(e) => setAgreed(e.target.checked)}
        />
        <span className="text-gray-700">{t('legal.consent')}</span>
      </label>

      <button
        className="btn-primary w-full"
        disabled={!agreed || downloading || !videoUrl}
        onClick={handleDownload}
      >
        {downloading ? t('legal.downloading') : t('legal.downloadBtn')}
      </button>
    </div>
  );
}
